import Vue from 'vue'
import Vuex from 'vuex'

import api from '../services'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    login: ''
  },
  mutations: {
    change(state, data) {
      state.login = data
      localStorage.setItem('mt_lgdata', JSON.stringify(data));
    }
  },
  actions: {
    SEND_MAIL({ commit},data) {
      api.sendMail(data).then(d => {
        return d;
      }).catch(err => {
        console.log(err);
      })

    },
  },
  getters: {
    login: state => state.login,
    isLogin: state => state.login != null && state.login.name && state.login.name != null,
  }
});

